<template>
  <BreadCrumb PageTitle="Placeholders" />
  <PlaceholdersContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import PlaceholdersContent from "../../template-components/UIElements/Placeholders/PlaceholdersContent.vue";

export default defineComponent({
  name: "PlaceholdersPage",
  components: {
    BreadCrumb,
    PlaceholdersContent,
  },
});
</script>